var React = require('react');

function Coffee (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M559.76 480H48.36c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512.06 32h-392a23.94 23.94 0 0 0-24 24v232a96 96 0 0 0 96 96h192a96 96 0 0 0 96-96h32a128 128 0 0 0 0-256zm0 192h-32V96h32a64 64 0 0 1 0 128z","className":"fa-primary","key":2})]);
}

Coffee.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Coffee;

Coffee.default = Coffee;
